import Vue from 'vue';
import VueRouter from 'vue-router';
// import { setToken } from '../api/request'

Vue.use(VueRouter);

const routes = [
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: (resolve) =>
      require(["views/privacy-policy/index.vue"], resolve),
  },
  {
    path: "/privacy-policy-ovopark",
    name: "privacy-policy-ovopark",
    component: (resolve) =>
      require(["views/privacy-policy-ovopark/index.vue"], resolve),
  },
  {
    path: "/privacy-policy-ovopark-jd",
    name: "privacy-policy-ovopark-jd",
    component: (resolve) =>
      require(["views/privacy-policy-ovopark/index_jd.vue"], resolve),
  },
  {
    path: "/user-agreement",
    name: "user-agreement",
    component: (resolve) =>
      require(["views/user-agreement/index.vue"], resolve),
  },
  {
    path: "/user-agreement-jd",
    name: "user-agreement-jd",
    component: (resolve) =>
      require(["views/user-agreement/index_jd.vue"], resolve),
  },
  {
    path: "/precautions",
    name: "precautions",
    component: (resolve) => require(["views/precautions/index.vue"], resolve),
  },
  {
    path: "/promotional-advertising",
    name: "promotional-advertising",
    component: (resolve) =>
      require(["views/promotional-advertising/index.vue"], resolve),
  },
  // 年终终结
  {
    path: "/year-report",
    name: "year-report",
    component: (resolve) => require(["views/year-report/index.vue"], resolve),
  },
  {
    path: "/cooperation-agreement",
    name: "cooperation-agreement",
    component: (resolve) =>
      require(["views/cooperation-agreement/index.vue"], resolve),
  }
];

const router = new VueRouter({
  routes
});
export default router;
